import { MobileApplicationConfig } from '@actassa/api';

export class SetAppSettings {
    public static readonly type = '[Root state] Set app settings';

    constructor(public payload: Partial<MobileApplicationConfig>) {}
}
